module.exports = __webpack_public_path__ + "static/image 104-bde06ddb94016a6e6cc7dd282aca9218.png";